
import { ArrowRight } from "lucide-react";
import { Button, ContactButton } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { HeroBackground } from "@/components/ui/hero-background";

export const HeroSection = () => {
  return (
    <HeroBackground 
      pattern="roadmap" 
      colorScheme="purple" 
      height="h-[600px] md:h-[700px]"
      className="animate-fade-in"
    >
      {/* Content container */}
      <Container className="py-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 id="hero-heading" className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight tracking-tight text-gray-900 animate-fade-up">
            Microsoft 365{" "}
            <span className="bg-gradient-to-r from-edgefi-purple to-edgefi-amethyst bg-clip-text text-transparent">
              Specialized Security
            </span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed font-light animate-fade-up" style={{ animationDelay: "0.1s" }}>
            Transform your Microsoft 365 environment from a vulnerability into your strongest defense. We specialize in securing your digital workspace without compromising productivity.
          </p>
          <div className="flex flex-wrap justify-center gap-4 animate-fade-up" style={{ animationDelay: "0.2s" }}>
            <ContactButton
              className="bg-edgefi-purple hover:bg-edgefi-purple/90 text-white group"
              modalTitle="Microsoft 365 Security Assessment"
              modalDescription="Let's discuss your Microsoft 365 security needs. Fill out the form below and our experts will contact you to schedule your free assessment."
              variant="cta"
              size="lg"
            >
              Get a Security Assessment
              <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </ContactButton>
            <a href="#services">
              <Button variant="outline" size="lg" className="border-edgefi-purple/20">
                View Our Services
              </Button>
            </a>
          </div>
        </div>
      </Container>
    </HeroBackground>
  );
};
